
import { 
  SLACK_WEBHOOK_RECEIVER, 
  APP_NAME,
  SUPABASE_URL
} from "@/config/environment";

/**
 * Gets the Slack endpoint URLs for the app
 * @returns Object containing the endpoint URLs
 */
export const getSlackEndpoints = () => {
  // Display a warning in the console if we're using localhost
  if (SUPABASE_URL.includes('localhost')) {
    console.warn(
      'Using localhost for Slack integration. ' +
      'For production use, set VITE_SUPABASE_URL environment variable ' +
      'to your Supabase project URL.'
    );
  }
  
  return {
    events: SLACK_WEBHOOK_RECEIVER,
    interactivity: SLACK_WEBHOOK_RECEIVER,
    commands: SLACK_WEBHOOK_RECEIVER
  };
};

/**
 * Generates a Slack app manifest for easy setup
 * @returns The manifest as a JSON string
 */
export const generateSlackManifest = () => {
  const endpoints = getSlackEndpoints();
  
  const manifest = {
    display_information: {
      name: APP_NAME,
      description: "AI Marketing Assistant for your team",
      background_color: "#4A5568"
    },
    features: {
      bot_user: {
        display_name: "VirtuStaff",
        always_online: true
      },
      app_home: {
        home_tab_enabled: true,
        messages_tab_enabled: true,
        messages_tab_read_only_enabled: false
      }
    },
    oauth_config: {
      scopes: {
        bot: [
          "app_mentions:read",
          "channels:history",
          "channels:read",
          "chat:write",
          "files:read",
          "groups:history",
          "groups:read",
          "im:history",
          "im:read",
          "mpim:history",
          "mpim:read",
          "reactions:read",
          "team:read",
          "users:read"
        ]
      }
    },
    settings: {
      event_subscriptions: {
        request_url: endpoints.events,
        bot_events: [
          "app_mention",
          "message.channels",
          "message.groups"
        ]
      },
      interactivity: {
        is_enabled: true,
        request_url: endpoints.interactivity
      },
      org_deploy_enabled: false,
      socket_mode_enabled: false
    }
  };
  
  return JSON.stringify(manifest, null, 2);
};
